import styled from 'styled-components';

const ContainerStyled = styled.div`
  display: flex;
  padding: 32px 16px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

const SimcardResourcesWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  span {
    color: #0e141d;
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 26px;
  }
`;

const SimcardResourcesStyled = styled.div`
  display: flex;
  padding: 8px 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: #eff1f3;

  p {
    color: #494c66;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;

    b {
      font-weight: 700;
    }
  }
`;

const AdminInfoStyled = styled.div`
  display: flex;
  color: #494c66;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin-top: 48px;

  a {
    color: #4d008c;
    font-weight: 500;
    line-height: 20px;
    text-decoration-line: underline;
  }

  aside {
    margin-right: 8px;
    margin-bottom: auto;
  }
`;

export {
  ContainerStyled,
  SimcardResourcesStyled,
  SimcardResourcesWrapperStyled,
  AdminInfoStyled,
};
